export const breakpoints = {
  xs: 0,
  sm: 481,
  md: 768,
  lg: 1024,
  xl: 1440,
  xlPlus: 1728,
  xxl: 1920,
};
